(function () {
    function postUpdates(updates) {
        return fetch(''.concat(theme.routes.cartChange, '?t=').concat(Date.now()), {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ updates: updates })
        }).then(function (r) { return r.json(); });
    }

    function syncEngravings(cart) {
        var mainByBundle = {};
        cart.items.forEach(function (ci) {
            var p = ci.properties || {};
            var bid = p['__bundle_id'];
            if (bid && p['__is_engraving'] !== 'true') mainByBundle[bid] = ci;
        });

        var updates = {};
        var has = false;
        cart.items.forEach(function (ci) {
            var p = ci.properties || {};
            var bid = p['__bundle_id'];
            if (!bid || p['__is_engraving'] !== 'true') return;
            var main = mainByBundle[bid];
            if (!main) { updates[ci.key] = 0; has = true; return; }
            if (ci.quantity !== main.quantity) { updates[ci.key] = main.quantity; has = true; }
        });

        if (has) postUpdates(updates).then(function () { document.dispatchEvent(new CustomEvent('cart:build')); });
    }

    function lockEngravingQty() {
        document.querySelectorAll('.cart__item[data-engraving="true"] .js-qty__wrapper').forEach(function (w) {
            w.querySelectorAll('.js-qty__adjust').forEach(function (b) {
                b.setAttribute('disabled', 'disabled');
                b.style.pointerEvents = 'none';
            });
            var input = w.querySelector('.js-qty__num');
            if (input) { input.setAttribute('readonly', 'readonly'); input.classList.add('is-readonly'); }
        });
    }

    document.addEventListener('cart:updated', function (e) {
        if (e && e.detail && e.detail.cart) {
            syncEngravings(e.detail.cart);
            lockEngravingQty();
        }
    });

    document.addEventListener('DOMContentLoaded', function () { lockEngravingQty(); });

    if (window.theme && theme.cart && typeof theme.cart.getCart === 'function') {
        try { theme.cart.getCart().then(function (cart) { syncEngravings(cart); }); } catch (e) { }
    }
})();
